<template>
  <div>
    <gru-table :resource="'menu'" :fields="fields" :primaryKey="'menuId'"
               :enabledToolbar="true"
               :enabledDelete="true"
               :enabledAdd="true"
               :enabledExcel="false"
               :enabledPrint="false">
    </gru-table>
  </div>
</template>

<script>
import { router } from '../../router';
import { dbConstants } from "@/constants";
import { mapGetters } from 'vuex';
import { userContants } from "@/constants";

export default {
  name: 'MenuList',
  data: () => {
    return {
      menuTypes: [
        {text: 'Menu Item', value: 2},
        {text: 'Section', value: 1},
      ]
    }
  },
  computed:{ 
    ...mapGetters( "menu", ["parentMenusDropdown"] ),
    ...mapGetters( ["selectedLocaleIndex"] ),
    fields(){
      return [
        {text: 'Name', value: 'name'+ this.selectedLocaleIndex, sortable: true, editable: true},
        {text: 'Link', value: 'link', sortable: true},
        {text: 'Icon', value: 'icon'},
        {text: 'Menu Type', value: 'menuType', columnType: 'SELECT', optionValues: this.menuTypes},
        {text: 'Parent', value: 'parentId', optionValues: this.parentMenusDropdown, columnType: 'SELECT'},
        {text: 'Active', value: 'active', optionValues: userContants.allStateTypes, columnType: 'BOOLEAN'}
      ]
    } 
  },
  methods: {
    showQuery: function(e) {
      //console.log(e);
    }
  }
}
</script>
